import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import { AgroOverviewMapVariable } from 'types/Meteorology/Agro/Overview/Dashboard';
import {
  selectAgroOverviewSelectedVariable,
  setSelectedVariable,
} from 'redux/reducers/meteorologyAgroOverviewDashboardReducer';

import './index.scss';

export default function VariableSheet({
  open,
  dismiss,
  variables,
}: {
  open: boolean;
  dismiss: () => void;
  variables: AgroOverviewMapVariable[];
}) {
  const dispatch = useDispatch();
  const selectedVariable = useSelector(selectAgroOverviewSelectedVariable);

  const handleSelect = (nome: AgroOverviewMapVariable['nome']) => {
    dispatch(setSelectedVariable(nome));
    dismiss();
  };

  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Variável exibida"
      className="agro-overview-mobile-variable-sheet"
    >
      <div className="agro-overview-mobile-variable-list">
        {variables.map((variable) => (
          <button
            key={variable.nome}
            type="button"
            className={`agro-overview-mobile-variable-row${variable.nome === selectedVariable ? ' selected' : ''}`}
            onClick={() => handleSelect(variable.nome)}
            aria-pressed={variable.nome === selectedVariable}
          >
            <span className="agro-overview-mobile-variable-name">{variable.label}</span>
            {variable.unidade && (
              <span className="agro-overview-mobile-variable-unit">{variable.unidade}</span>
            )}
          </button>
        ))}
      </div>
    </BottomSheet>
  );
}
